import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTableViewIconProps extends SvgIconProps {}

/**
 * Component displays table view  svg icon
 * @param props -CcfTableViewIconProps
 * @returns commit svg icon
 * @example - <CcfTableViewIcon/>
 */
export function CcfTableViewIcon(props: CcfTableViewIconProps) {
  return (
    <SvgIcon {...props} width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path
        d="M16 15.6923V12.6634H1.99997V15.6923C1.99997 15.782 2.02883 15.8557 2.08653 15.9134C2.14423 15.9711 2.21795 16 2.3077 16H15.6923C15.782 16 15.8557 15.9711 15.9134 15.9134C15.9711 15.8557 16 15.782 16 15.6923ZM16 11.1635V6.8365H1.99997V11.1635H16ZM16 5.33655V2.3077C16 2.21795 15.9711 2.14423 15.9134 2.08653C15.8557 2.02883 15.782 1.99998 15.6923 1.99998H2.3077C2.21795 1.99998 2.14423 2.02883 2.08653 2.08653C2.02883 2.14423 1.99997 2.21795 1.99997 2.3077V5.33655H16ZM2.3077 17.5C1.80257 17.5 1.375 17.325 1.025 16.975C0.675 16.625 0.5 16.1974 0.5 15.6923V2.3077C0.5 1.80257 0.675 1.375 1.025 1.025C1.375 0.675 1.80257 0.5 2.3077 0.5H15.6923C16.1974 0.5 16.625 0.675 16.975 1.025C17.325 1.375 17.5 1.80257 17.5 2.3077V15.6923C17.5 16.1974 17.325 16.625 16.975 16.975C16.625 17.325 16.1974 17.5 15.6923 17.5H2.3077Z"
        fill="black"
        fill-opacity="0.56"
      />
    </SvgIcon>
  );
}

export default CcfTableViewIcon;
